import { Vue, Component } from 'vue-property-decorator';
import BScroll, { BsOption } from 'better-scroll';

@Component
export default class BSMixin extends Vue {
  /* eslint-disable no-new */
  /* eslint-disable class-methods-use-this */
  initBS(dom: any, options?: Partial<BsOption>) {
    return new BScroll(dom, Object.assign({
      scrollY: true,
      click: true,
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300,
      },
      scrollbar: {
        fade: false,
      },
    }, options));
  }
}
